import React from "react";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import { formatMoney } from "../config/store";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="shop-container">
      <header className="shop-header">
        <div className="breadcrumbs">
          <Link to="/">HOME</Link> / <span>SHOP</span>
        </div>
        <h1>Curated Collections</h1>
      </header>

      <div className="shop-controls">
         
        <div className="product-count">{productData.length} PRODUCTS</div>
        
      </div>

      <div className="product-grid">
        {productData.map((product) => (
          <div key={product.id} className="product-card">
            <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
              <div className="product-image-wrapper">
                <img src={product.image} alt={product.name} />
                {product.inventory === 0 ? (
                  <span className="badge sold-out">SOLD OUT</span>
                ) : product.compareAtPrice ? (
                  <span className="badge sale">SALE</span>
                ) : null}
              </div>
              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <div className="product-price">
                  {product.compareAtPrice && <span className="original-price">{formatMoney(product.compareAtPrice)}</span>}
                  <span className="sale-price">{formatMoney(product.price)}</span>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Shop;
